import { useState, useContext } from "react";
import { useParams } from "@tanstack/react-router";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useReturnPendingCard } from "../../state/returnPendingCardState";
// Component imports
import { ReturnAddress } from "./ReturnAddress";
import { ReturnDetails } from "./ReturnDetails";
import { ReturnLines } from "./ReturnLines";
import { ReturnDisclaimer } from "./ReturnDisclaimer";
import { ReturnHeader } from "./ReturnHeader";
import { ReturnType } from "./ReturnType";
import { ReturnDropOff } from "./ReturnDropOff";
// MUI imports
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function ReturnOrderPendingCard() {
  const { setAlertNotification } = useContext(AlertNotificationContext);
  const { id } = useParams({ strict: false });
  const { isPending, isError, isSuccess, error, data } =
    useReturnPendingCard(id);

  const [returnOrder, setReturnOrder] = useState({
    returnOrder: {},
    returnOrderLines: [],
  });

  // Success Function
  const successFunc = () => {
    setReturnOrder(data.data.data.data.data);
  };
  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      <Box>
        {returnOrder.returnOrder && (
          <Box>
            <ReturnHeader
              no={returnOrder.returnOrder.no}
              status={returnOrder.returnOrder.status}
            />

            <Grid
              sx={{ pt: 2 }}
              container
              spacing={{ xs: 2, md: 2 }}
              columns={{ xs: 1, sm: 1, lg: 3 }}
            >
              <Grid
                size={{
                  xs: 1,
                  sm: 1,
                  lg: 3,
                }}
              >
                <ReturnType returnOrder={returnOrder} />
              </Grid>
              <Grid
                size={{
                  xs: 1,
                  sm: 1,
                  lg: 1,
                }}
              >
                <ReturnDetails returnOrder={returnOrder.returnOrder} />
              </Grid>
              {returnOrder.returnOrder.dropOff !== "Yes" ? (
                <Grid
                  size={{
                    xs: 1,
                    sm: 1,
                    lg: 2,
                  }}
                >
                  <ReturnAddress returnOrder={returnOrder.returnOrder} />
                </Grid>
              ) : (
                <Grid
                  size={{
                    xs: 1,
                    sm: 1,
                    lg: 2,
                  }}
                >
                  <ReturnDropOff returnOrder={returnOrder.returnOrder} />
                </Grid>
              )}
            </Grid>
          </Box>
        )}
      </Box>
      <Box sx={{ pt: 1 }}>
        {returnOrder.returnOrderLines &&
        returnOrder.returnOrderLines.length !== 0 ? (
          // <Typography>{JSON.stringify(returnOrderLines)}</Typography>
          <ReturnLines returnLines={returnOrder.returnOrderLines} />
        ) : (
          !isPending && <Typography>No Data</Typography>
        )}
      </Box>
      <Box sx={{ pt: 1 }}>
        <ReturnDisclaimer />
      </Box>
    </>
  );
}
